import { Text, Tooltip } from '@ad-lucy/ui';
import { useI18n } from '@i18n/i18n.utils';
import { useEffect, useState } from 'react';
import { ButtonIcon, EllipsisText, StyledButton } from './Navbar/components';

// Class used to be able to apply styles to the button from the sidebar container
export const SidebarModeControlButtonClass = 'SidebarModeControlButton';

type SidebarModeControlButtonProps = Readonly<{
  collapsed?: boolean;
  onClick: () => void;
}>;

export default function SidebarModeControlButton({
  collapsed,
  onClick,
}: SidebarModeControlButtonProps) {
  const { t } = useI18n();

  const [tooltipOpen, setTooltipOpen] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies:intended
  useEffect(() => {
    setTooltipOpen(false);
  }, [collapsed]);

  return (
    <Tooltip
      delayDuration={0}
      open={collapsed ? tooltipOpen : false}
      onOpenChange={setTooltipOpen}
    >
      <Tooltip.Trigger asChild={true}>
        <StyledButton
          data-testid="sidebar-toggle-mode"
          collapsed={collapsed}
          className={SidebarModeControlButtonClass}
          onClick={onClick}
        >
          <ButtonIcon
            collapsed={collapsed}
            type={collapsed ? 'IconChevronRight' : 'IconChevronLeft'}
            size={collapsed ? 'md' : 'lg'}
          />
          {!collapsed && (
            <Text
              color="currentColor"
              size="md"
              weight="medium"
              as={EllipsisText}
            >
              {t('navigation.collapse')}
            </Text>
          )}
        </StyledButton>
      </Tooltip.Trigger>
      <Tooltip.Content side="right">{t('navigation.expand')}</Tooltip.Content>
    </Tooltip>
  );
}
